declare global {
  interface Window {
    chatbase?: any;
  }
}

let chatbaseLoaded = false;

export const initializeChatbase = (): void => {
  if (chatbaseLoaded || typeof window === 'undefined') {
    return;
  }

  if (!window.chatbase || window.chatbase("getState") !== "initialized") {
    window.chatbase = (...args: any[]) => {
      if (!window.chatbase.q) {
        window.chatbase.q = [];
      }
      window.chatbase.q.push(args);
    };

    window.chatbase = new Proxy(window.chatbase, {
      get(target, prop) {
        if (prop === "q") {
          return target.q;
        }
        return (...args: any[]) => target(prop, ...args);
      }
    });
  }

  const onLoad = () => {
    const script = document.createElement("script");
    script.src = "https://www.chatbase.co/embed.min.js";
    script.id = "MSgf7RcD4oszfg6wnfxcW";
    script.setAttribute("domain", "www.chatbase.co");
    document.body.appendChild(script);
    chatbaseLoaded = true;
  };

  if (document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener("load", onLoad);
  }
};

export const isChatbaseLoaded = (): boolean => {
  return chatbaseLoaded;
};
